import { createI18n } from 'vue-i18n';

 let lang = 'es-AR'

export function loadLang() {
  const modules: Record<string, any> = import.meta.glob('./lang/*.ts', { eager: true });
  const langs: Record<string, any> = {};

  for (const path in modules) {
    const name = path.replace(/(\.\/lang\/|\.ts)/g, '');
    langs[name] = modules[path].lang;
  }
  return langs;
}

export const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || lang, // 默认取本地缓存
  fallbackLocale: lang,
  messages: loadLang(),
});

// 设置语言
export function setLang(locale?: string) {
  if (locale) {
    localStorage.setItem('lang', locale);
  }
  i18n.global.locale.value = locale || localStorage.getItem('lang') || lang;
}

// 🔥 获取当前语言
export function getLang(): string {
  return i18n.global.locale.value;
}
